import { Empty } from "antd";
import classNames from "classnames";
import { ReactNode } from "react";
import { Post } from "store/posts/postConstants";
import PostCard from "../../PostCard/PostCard";

// Renamed PostCardList to focus solely on the list layout
const PostCardList = <T extends Post = Post>({
  postList,
  children,
  className,
  condensed,
}: {
  postList: T[];
  className?: string;
  condensed?: boolean;
  children?: (...args: Parameters<Parameters<Array<T>["map"]>[0]>) => ReactNode;
}) => {
  return postList.length ? (
    <div
      className={classNames(
        "pb-8 flex w-full flex-col items-center px-4",
        condensed ? "gap-4" : "gap-14",
        className
      )}
    >
      {postList.map((post, ...args) =>
        children ? (
          children(post, ...args)
        ) : (
          <div key={post.id}>
            <PostCard post={post} />
          </div>
        )
      )}
    </div>
  ) : (
    <Empty className="my-auto" description="Nothing to show" />
  );
};

export default PostCardList;
